import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { push } from 'connected-react-router'

import {
  getIdentityStage,
  getIdentityActiveProTrackWithLevelName,
  hasAbilityToSelectNewProTrack,
  isUserCanSwitchProtrack,
} from 'store/entities/identity/selectors'
import { modal } from 'store/entities/modal/actions'
import ActiveProTracks from './ActiveProTracks'

const mapStateToProps = createStructuredSelector({
  stage: getIdentityStage,
  proTrackNameWithLevelName: getIdentityActiveProTrackWithLevelName,
  hasAbilityToSelectNewProTrack,
  isUserCanSwitchProtrack,
})

const mapDispathcToProps = dispatch => ({
  showModal: modalComponent => dispatch(modal.show(modalComponent)),
  goToSelectProTrack: () => dispatch(push('/select-protrack')),
})

export default connect(mapStateToProps, mapDispathcToProps)(ActiveProTracks)
